export class HttpError {
  constructor(
    public type: string,
    public message: string,
    public code: number
  ) {}
}
